import { useState, useEffect } from "react";
import _ from "lodash";

const CHAR_SEPARATOR = "###";

function mapToList(tagMap) {
  return Object.entries(tagMap)
    .filter(([key, value]) => value)
    .map(entry => {
      const [key, value] = entry;
      const [tagId, tagValue] = _.split(key, CHAR_SEPARATOR);
      return {
        tag: tagId,
        value: tagValue
      };
    });
}

export function useTagValuesState(onChange = _.noop) {
  const [state, setState] = useState({});

  useEffect(() => {
    const values = mapToList(state);
    onChange(values);
  }, [state]);

  const getKey = ({ tag, value }) => `${tag}${CHAR_SEPARATOR}${value}`;

  const handleCheck = args => {
    setState(prevState => {
      const key = getKey(args);
      const currentValue = prevState[key] || false;
      const newState = !currentValue;
      const updatedState = {
        ...prevState,
        [key]: newState
      };

      return updatedState;
    });
  };

  const isChecked = args => {
    const key = getKey(args);
    return state[key] || false;
  };

  const cleanState = () => {
    setState({});
  };

  return {
    onChange: handleCheck,
    isChecked,
    state,
    cleanState
  };
}



// WEBPACK FOOTER //
// ./src/components/tags-manager/tag-values-selector/state.js